import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsSearch = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M7.5337396,11.0264435c0-0.2602577,0.2277274-0.4294233,0.5920892-0.4294233
		c0.4294233,0,0.6831818,0.2082071,0.7742634,0.6441412h1.1126051c-0.1366339-1.021512-0.930419-1.4574461-1.847827-1.4574461
		c-1.0865741,0-1.7046943,0.598588-1.7046943,1.340332c0,1.7502346,2.6090922,0.9954805,2.6090922,1.9844618
		c0,0.30581-0.2472477,0.4944963-0.7157125,0.4944963s-0.7742639-0.2407379-0.8588467-0.676671H6.3951144
		c0.1561546,1.0085011,0.9043984,1.4899759,1.9519305,1.4899759c1.0345335,0,1.7892761-0.5270262,1.7892761-1.4379244
		C10.1363211,11.1695881,7.5337396,11.9698839,7.5337396,11.0264435z"
        />
        <path
          d="M11.535183,9.8878183l-1.6136007,4.4243889h1.0475435l0.2927895-0.8263159h1.7372246l0.2927885,0.8263159
		h1.1126051l-1.6201115-4.4243889H11.535183z M11.548193,12.6855965l0.4489441-1.2752705l0.1366339-0.5009956l0.1301346,0.5009956
		l0.4489441,1.2752705H11.548193z"
        />
        <polygon
          points="15.861968,12.7896996 15.7318335,13.310216 15.5951996,12.7896996 14.5671768,9.8878183 
		13.4610825,9.8878183 15.0876932,14.3122072 16.3174114,14.3122072 17.9440346,9.8878183 16.8899803,9.8878183 	"
        />
        <rect
          x="17.9569893"
          y="9.8878183"
          width="1.0410327"
          height="4.4243889"
        />
        <path
          d="M21.4379158,9.7837152c-1.3728523,0-2.2186985,0.8913879-2.2186985,2.3228025
		c0,1.4249153,0.8458462,2.3097925,2.2186985,2.3097925c1.3663635,0,2.2122002-0.8848772,2.2122002-2.3097925
		C23.650116,10.6751032,22.8042793,9.7837152,21.4379158,9.7837152z M21.4379158,13.5639639
		c-0.7287235,0-1.1516361-0.5465364-1.1516361-1.4574461c0-0.9174089,0.4229126-1.4704561,1.1516361-1.4704561
		c0.7222233,0,1.1451359,0.5595579,1.1451359,1.4704561C22.5830517,13.0174274,22.1601391,13.5639639,21.4379158,13.5639639z"
        />
        <path
          d="M0.3617854,12.48102c0.2385087,0.7992964,0.8469067,1.4351606,1.6342962,1.7093754l0.1213156,0.0416584
		V9.5836897l-1.767513,2.8579607L0.3617854,12.48102z"
        />
        <path
          d="M3.1117113,9.694932L2.9903955,9.6528149V14.30301l1.7560701-2.8597918l-0.0114455-0.0389118
		C4.500176,10.6068411,3.8958976,9.9709768,3.1117113,9.694932z"
        />
      </g>


    
    </SvgIcon>
  );
});

export default AppIconsSearch;
